<template>
  <v-card
    no-gutter
    style="
      width: 100% !important;
      height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
    "
    class="hide-scrollbar"
  >
    <v-card-title class="headline" style="background: transparent">{{
      module.title
    }}</v-card-title>
    <v-data-table
      :headers="headers"
      :items="tags"
      :items-per-page="10"
      :single-expand="expanded"
      item-key="deveui"
      class="elevation-1"
      style="overflow-y: auto; padding-bottom: 3rem"
      dense
      show-expand
    >
      <template v-slot:[`item.active`]="{ item }">
        <v-icon dark :color="getIconColor(hasRecentData(item))">{{
          hasRecentData(item)
        }}</v-icon>
      </template>
      <template v-slot:[`item.vdd`]="{ item }">
        {{ batteryLevel(item) }}
      </template>
      <template v-slot:[`item.rssi`]="{ item }">
        {{ getRSSI(item) }}
      </template>
      <template v-slot:[`item.alarm`]="{ item }">
        <v-icon dark :color="alarmActive(item)">timer</v-icon>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ lastDataTime(item) }}
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length + 1" class="px-0">
          <v-data-table
            :headers="[
              {},
              { text: $t('tagdata.fields.key'), value: 'key' },
              { text: $t('tag.fields.latestValue'), value: 'value' },
            ]"
            :items="item.data"
            item-key="key"
            hide-default-footer
            disable-sort
            dense
            @click:row="clickedRow"
            disable-pagination
          >
          </v-data-table>
        </td>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <TagHistoryDialog
        :dialogTrigger="dialogTrigger"
        :dialog="dialog"
        v-on:dialog-toggle="dialog = !dialog"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TagHistoryDialog from "@/components/common/TagHistoryDialog";

export default {
  name: "SensorOverviewList",
  props: ["module"],

  data() {
    return {
      search: "",
      expanded: false,
      dialog: false,
      deleting: false,
      tags: [],
      dialogTrigger: null,
      headers: [
        { text: this.$t("tag.fields.name"), value: "name" },
        { text: this.$t("tag.fields.battery"), value: "vdd" },
        {
          text: "RSSI",
          value: "rssi",
        },

        {
          text: this.$t("tag.fields.latestValue"),
          value: "createdAt",
          dataType: "Date",
        },

        {
          text: this.$t("tag.fields.activeData"),
          value: "active",
          sortable: false,
        },

        {
          text: this.$t("tag.fields.activeAlarm"),
          value: "alarm",
          filterable: false,
          sortable: false,
        },
        { text: "", value: "action", sortable: false },
      ],
    };
  },

  computed: {
    ...mapState("users", ["currentUser", "userCompany", "hasCompany"]),
    ...mapState("companies", ["status", "companyApps"]),
    ...mapState("tag", { storeTags: "tags", tagStatus: "status" }),
    ...mapState("tagData", { tagDataStatus: "status" }),
    ...mapState("alarms", { alarms: "alarms" }),

    keysForTag(deveui) {
      return this.tags.filter((t) => {
        t.deveui == deveui;
      });
    },
  },

  methods: {
    ...mapActions("tag", {
      getTags: "getLatestForCompany",
    }),
    ...mapActions("alarms", ["getAlarms"]),

    alarmActive(item) {
      let match = false;
      this.alarms.forEach((alarm) =>
        alarm.tag.deveui == item.deveui ? (match = true) : (match = false)
      );

      if (match) {
        return "error";
      }
      return "grey";
    },

    batteryLevel(item) {
      if (item.vdd) return item.vdd + " V";
      else return "N/A";
    },

    getRSSI(item) {
      if (item.rssi) return item.rssi + " dBm";
      else return "N/A";
    },

    RSSIColor(item) {
      if (item.data && item.data.length > 0)
        item.data.forEach((d) => {
          if (d.key == "rssi") {
            let rssiValue = d.value;

            if (rssiValue > -80) return "green--text";
            else if (rssiValue > -105) return "light-green--text";
            else if (rssiValue > -115) return "orange--text";
            else return "red--text";
          }
        });
    },

    hasRecentData(item) {
      if (item.latestTime) {
        if (this.timeWithinHours(item.latestTime, 24)) return "mdi-check";
        else return "mdi-sleep";
      } else return "mdi-help";
    },

    lastDataTime(item) {
      if (item.latestTime) {
        return this.humanDate(item.latestTime, "dd MMM - HH:mm");
      }
      return "N/A";
    },

    getIconColor(iconName) {
      switch (iconName) {
        case "mdi-sleep":
          return "yellow";
        case "mdi-help":
          return "error";
        case "mdi-battery-unknown":
          return "grey";
        case "mdi-battery-50":
          return "yellow";
        case "mdi-battery-10":
          return "error";
        default:
          return "success";
      }
    },

    clickedRow(caller) {
      this.dialogTrigger = caller;
      this.dialog = true;
    },
  },

  async mounted() {
    if (this.hasCompany && this.currentUser) {
      await this.getTags();
      this.tags = this.storeTags.slice();

      await this.getAlarms();
    }
  },
  components: {
    TagHistoryDialog,
  },
};
</script>
<style>
</style>
